import * as React from 'react';
const { useEffect, useContext } = React;
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider as ThemeStyledProvider } from 'styled-components';
import { ThemeProvider as ThemeMUIProvider } from '@material-ui/styles';
import { enableChartsTheme } from '@seeneco-ui/core';
import { Auth } from '@seeneco-ui/business';

import '@stylesheet/app.css';
import { store } from '@store';
import { createReactMaterialTheme, createStyledTheme } from '@stylesheet';
import Shell from '@shared/components/shell';


const brand = process.env.BRAND;
const brandValue = { brand };
const BrandContext = React.createContext(brandValue);
const themeStyled = createStyledTheme(brand);
const ThemeContext = React.createContext(themeStyled);
const themeMUI = createReactMaterialTheme(brand);

type AppProps = {} & RouteComponentProps;

const App: React.SFC<AppProps> = ({ location, history }) => {
	const { isAuthorized, loginPath } = Auth.useAuthContext();
	const theme = useContext(ThemeContext);

	useEffect(() => {
		if (!isAuthorized && location.pathname !== loginPath) {
			history.push(loginPath);
		}
	});

	useEffect(() => {
		enableChartsTheme(theme);
	}, []);

	return (
		<ReduxProvider store={store}>
			<ThemeContext.Provider value={themeStyled}>
				<ThemeStyledProvider theme={themeStyled}>
					<ThemeMUIProvider theme={themeMUI}>
						<BrandContext.Provider value={brandValue}>
							<Shell />
						</BrandContext.Provider>
					</ThemeMUIProvider>
				</ThemeStyledProvider>
			</ThemeContext.Provider>
		</ReduxProvider>
	);
}

const AppWithRouter = withRouter(App);

export {
	AppWithRouter as App,
	store,
	BrandContext,
	ThemeContext,
};
